import { useEffect, useState } from 'react';
import { createFavouriteApi } from 'redux-state/favourites/types.js';
import { PageLocationSummary } from 'types/markerTypes/location.page.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { makeRequest } from 'utilities/fetch/api-gateway.js';
import { FavouriteCurrentLocationHook } from './location-favourite-properties.js';

// export type CurrentLocationFavouriteProps = {
//   currentLocationFavourite: ILocationSummary | undefined;
//   demo: boolean;
// };

// function favCurrentLocationReducer(
//   state: CurrentLocationFavouriteProps = {
//     currentLocationFavourite: undefined,
//     demo: false,
//   },
//   action: CurrentAction,
// ) {
//   console.log(action.type);
//   switch (action.type) {
//     case CurrentLocationActions.updateLocation: {
//       if (state.demo) {
//         return {
//           currentLocationFavourite: action.favourite,
//           demo: false,
//         };
//       }
//       return state;
//     }
//     case CurrentLocationActions.displayDemo:
//       if (action.display !== state.demo) {
//         return {
//           ...state,
//           demo: action.display,
//         };
//       }
//       return state;

//     default:
//       return state;
//   }
// }

export const FavouriteCurrentLocation = ({
  location,
}: {
  location?: PageLocationSummary;
}): {
  currentLocationFavourite: ILocationSummary | undefined;
} => {
  // const [currentLocationFavourite, dispatch] = useReducer(favCurrentLocationReducer, {
  //   currentLocationFavourite: undefined,
  //   demo: false,
  // });

  const [currentLocationFavourite, setCurrentLocationFavourite] = useState<ILocationSummary>();

  const { type, key, favouriteKey, favouriteType } = FavouriteCurrentLocationHook({ location });

  useEffect(() => {
    const fn = async () => {
      if (key && type) {
        const favouriteApiKey = createFavouriteApi({ key, type, favouriteKey, favouriteType });
        const newCurrentLocationFavouriteObject = await makeRequest<ILocationSummary>({
          path: `/favourites/${favouriteApiKey}`,
          options: { credentials: 'include' },
          apiPrefix: true,
        });
        setCurrentLocationFavourite(newCurrentLocationFavouriteObject);
      }
    };
    fn();
  }, [type, key, favouriteKey, favouriteType]);

  return {
    currentLocationFavourite,
  };
};
